<template>  
  <v-container>
    <v-row>
      <v-col xs="12">
        <v-card class="elevation-5">
          <v-card-title>
           Pedidos Pagos
          </v-card-title>

          <v-container fluid grid-list-xl>
            <Filters @updateReport="updatePayments" />
          </v-container>
          
        </v-card>

        
          <v-col xs="12">
              <v-container fluid grid-list-xl>
                <List :key="payments" />
              </v-container>

          </v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Filters from './Filters';
import List from './List';

export default {
  name: 'Index',
  components:{
    Filters,
    List
  },
  methods: {
    updatePayments() {
      this.payments++;
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.$store.dispatch('fetchAttendantsReport');
  },
  data () {
    return {
      payments: 0,

    };
  }
}
</script>

<style lang="css" scoped>
</style>